import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import { Container, Row, Col, Spinner} from "react-bootstrap";
import { showToast } from '../../../components/common/notification/Notification';
import PostDetailCard from "./PostDetailCard";

const PostDetail = ({back, ownerId: setOwnerId}) => {
  const { Id } = useParams(); 
  const [postData, setPostData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isError, setIsError] = useState(false);
  const loggedInUser = useSelector((state) => state.auth.user);
  const token = loggedInUser?.refreshToken; 
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const assetUrl = process.env.REACT_APP_ASSET_URL;

  const [mediaData, setMediaData] = useState({
    images: [],
    promotion_videos: [],
    attachments: [],
  });

  useEffect(() => {
    fetchPostItem();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Id]);

  const fetchPostItem = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${baseUrl}/property/lead/${Id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      ); 
      console.log(response.data.lead);

      if (response.status === 200) {
        const post = response.data.lead;
        if (setOwnerId && post.user) {
          setOwnerId(post.user.id); 
        }
        // First update the main data
        setPostData({
          creatorName: post.customer_name,
          city: post.city_name,
          state: post.state_name,
          country: post.country_name,
          description: post.description,
          createdOn: post.created_on,
          images: post.images,
          videos: post.videos,
          attachments: post.attachments,
          photo: post.customer.photo,
          service: post.service,
        });

        console.log("postData", postData);

        // Now use raw response directly to update media
        setMediaData({
          images: (post.images || []).map((img) => ({
            url: assetUrl + img.image_url,
            // url: `${assetUrl}${img.image_url}`, 
          })),
          videos: (post.videos || []).map((video) => ({
            url: assetUrl + video.url_path,
          })),
          attachments: (post.attachements || []).map((attachment) => ({
            url: assetUrl + attachment.attachment_url,
          })),
        });
      }  
      else {
        showToast('Failed to fetch data', { type: 'error' });
      }
    } catch (error) {
      setIsError(true);
      console.error('Fetch error:', error);
      showToast('Error fetching data', { type: 'error' }); 
    } finally {
      setIsLoading(false);
    }
  };


  if (isLoading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
      </Container>
    );
  }

  if (!postData) {
    return null; 
  }

  return (
    <div className="container py-4">

      <PostDetailCard
        creatorName={postData.creatorName}
        description={postData.description}
        createdOn={postData.createdOn}
        state={postData.state}
        city={postData.city}
        images={mediaData.images}
        videos={mediaData.videos}  
        attachments={mediaData.attachments}
        service={postData.service} 
      />
      <Link className="btn btn-sm btn-primary fs-5 px-4 py-2 mt-4" to={back}>
        Back
      </Link>
    </div>
  );
}
export default PostDetail;